import React from "react";
import Button, { ButtonThemes } from "../../ui-components/button/button";
import "./appointmentSummary.scss";

export interface AppointmentResultBlockProps {
  probillNumber: string;
  onClickView: () => void;
};

const AppointmentOuterResultBlock: React.FC<AppointmentResultBlockProps> = (props) => {

  return (
    <div className="xgs-appointment-summary__outer-appointment-block">
      <div>
        <p>The probill {props.probillNumber} was found without using filters.</p>
        <p>To view information about this probill or create a new appointment, click &quot;View&quot;.</p>
      </div>
      <Button
        theme={ButtonThemes.blue}
        type="submit"
        className="xgs-appointment-summary__outer-appointment-block__button"
        onClick={props.onClickView}
      >
        View
      </Button>
    </div>
  );
};

export default AppointmentOuterResultBlock; 